import React, { useContext, useEffect, useRef, useState } from "react";
import { PDFViewer, Document, Page, Text, View, StyleSheet, pdf, Font } from "@react-pdf/renderer";
import NewFont from "../../assets/fonts/NotoSansArabic-VariableFont_wdth\,wght.ttf";
import AppContext from "../../context/AppContext";

Font.register({
  family: "ArabicFont",
  src: NewFont,
});

const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 12, fontFamily: "ArabicFont" },
  header: { fontSize: 16, marginBottom: 10, textAlign: "center", fontWeight: "bold" },
  section: { marginBottom: 10 },
  label: { fontWeight: "bold" },
  table: { display: "table", width: "100%", borderStyle: "solid", borderWidth: 1, marginTop: 10 },
  tableRow: { flexDirection: "row" },
  tableHeader: {
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
    padding: 5,
    borderStyle: "solid",
    borderWidth: 1,
    textAlign: "center",
    flex: 1,
  },
  tableCell: {
    padding: 5,
    borderStyle: "solid",
    borderWidth: 1,
    textAlign: "center",
    flex: 1,
    wordBreak: "break-word",
    whiteSpace: "normal",
    height: "auto",
    maxWidth: "100%",
    minHeight: 40,
    flexWrap: "wrap",
  },
    footer: {
    marginTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#cccccc',
    paddingTop: 10,
    textAlign: 'center',
    fontSize: 10,
  },
  label: {
    fontWeight: 'bold',
  },
  creationDate: {
    fontSize: 8,
    color: '#666666',
    marginTop: 5,
  }
});

export const MyDocument = ({ data, accountNo }) => (
  <Document>
    <Page size="A4" style={styles.page}>

      <Text style={styles.header}>Payment Preview</Text>
      <View style={styles.section}>
        <Text>
          <Text style={styles.label}>Account No :</Text>
          {accountNo ?? "N/A"}
        </Text>
        <Text>
          <Text style={styles.label}>Advance Amount: </Text>
          {data.advanceAmount ?? "N/A"}
        </Text>
        <Text>
          <Text style={styles.label}>Outstanding After Advance: </Text>
          {data.outstandingAfterAdvance ?? "N/A"}
        </Text>
        <Text>
          <Text style={styles.label}>Current Outstanding: </Text>
          {data.currentOutstanding ?? "N/A"}
        </Text>
          <Text>
          <Text style={styles.label}>Date: </Text>
          {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
        </Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={styles.tableHeader}>Payment Date</Text>
          <Text style={styles.tableHeader}>Payment Amount</Text>
          <Text style={styles.tableHeader}>Notes</Text>
        </View>

        {Array.isArray(data.instalments) && data.instalments.length > 0 ? (
          data.instalments.map((inst, index) => {
            const paymentDate = new Date(inst.paymentDate);
            const isDateValid = !isNaN(paymentDate.getTime());
            const formattedDate = isDateValid ?
              paymentDate.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) :
              "Invalid Date";

            return (
              <View key={index} style={styles.tableRow}>
                <Text style={styles.tableCell}>{formattedDate}</Text>
                <Text style={styles.tableCell}>{inst.paymentAmount.toFixed(2)}</Text>
                <Text style={[styles.tableCell, { textAlign: "left", flexWrap: "wrap" }]}>
                  {inst.notes ? inst.notes.trim() : "N/A"}
                </Text>
              </View>
            );
          })
        ) : (
          <View style={styles.tableRow}>
            <Text style={styles.tableCell} colSpan={3}>
              No installments available
            </Text>
          </View>
        )}
      </View>
    </Page>
  </Document>
);

const PDFViewerComponent = ({ data, onClose = () => { }, setPdfUrl }) => {
  const { setPdfData } = useContext(AppContext);
  const modalRef = useRef(null);
  const [pdfBlob, setPdfBlob] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    const generatePdf = async () => {
      const blob = await pdf(<MyDocument data={data} />).toBlob();
      setPdfUrl(blob);
    };
    generatePdf();
  }, [data, setPdfUrl]);

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
      <div ref={modalRef} className="relative bg-white p-4 rounded-lg">
        <PDFViewer style={{ width: "80vw", height: "80vh" }}>
          <MyDocument data={data} />
        </PDFViewer>
      </div>
    </div>
  );
};

export default PDFViewerComponent;
